import { settings } from "../settings/settings";

const BASE_LOGIN_SCOPES = ["offline_access", "openid", "profile", "email"];
export function getLoginScopes() {
    return [
        ...BASE_LOGIN_SCOPES,
        `${settings.clientId}`
    ]
}